import { render, staticRenderFns } from "./SupSwiper.vue?vue&type=template&id=280a66d2&scoped=true&"
import script from "./SupSwiper.vue?vue&type=script&lang=js&"
export * from "./SupSwiper.vue?vue&type=script&lang=js&"
import style0 from "./SupSwiper.vue?vue&type=style&index=0&id=280a66d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280a66d2",
  null
  
)

export default component.exports